import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import { Box, Stack, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

/**
 * The upload file component
 * @component
 *
 * @param {Object} props
 * @param {function} [props.setFicheros]
 * @param {Array<object>} props.ficheros
 * @param {number} props.maxFiles
 * @returns {JSX.Element}
 */

const InvoiceDropZone = ({ setFicheros, ficheros, maxFiles, sx = {} }) => {
  const onDrop = useCallback(async (files) => {
    if (files.length > maxFiles) {
      enqueueSnackbar(`No se puede subir más de ${maxFiles} ficheros`, {
        variant: 'error',
      })
      return
    }
    await Promise.all(
      files.map((file) => {
        return new Promise((resolve, reject) => {
          const name = file.name
          const mimeType = file.type
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => {
            setFicheros((prev) => [
              ...prev,
              {
                contenido_fichero: reader.result.split('base64,')[1],
                nombre_fichero: name,
                tipo_fichero: mimeType,
              },
            ])
            resolve()
          }
          reader.onerror = reject
        })
      }),
    ).catch((err) =>
      enqueueSnackbar('Se ha producido un error mientras se subían los ficheros', {
        variant: 'error',
      }),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  const removeFileHandler = (e, index) => {
    e.stopPropagation()
    setFicheros((prev) => prev.filter((item, _index) => _index !== index))
  }

  return (
    <Stack
      {...getRootProps({
        sx: {
          height: '60px',
          width: '100%',
          padding: '0 10px',
          borderRadius: '2px',
          border: '1px dashed',
          cursor: 'pointer',
          borderColor: '#b1b3b6',
          display: 'flex',
          overflow: 'hidden',
          alignItems: 'center',
          bgcolor: '#e2e2e2',
          ...sx,
        },
      })}
    >
      <input {...getInputProps()} />
      <Stack direction={'row'} flexGrow={1} sx={{ width: '100%' }} alignItems={'center'}>
        <Typography
          sx={{
            fontSize: '15px',
            ml: '40px',
            letterSpacing: '0.5px',
          }}
        >
          Zona para arrastrar y soltar ficheros
        </Typography>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            '& > .MuiTypography-root': {
              fontSize: '12px',
              color: '#a6a3a3',
              wordBreak: 'break-all',
              letterSpacing: '0.5px',
            },
          }}
        >
          {isDragActive && <Typography>Arrastra los ficheros aquí ...</Typography>}
          {ficheros.length === 0 && !isDragActive && (
            <Typography>Ningún fichero seleccionado</Typography>
          )}
          {!!ficheros.length && (
            <Stack
              direction={'flex'}
              alignItems={'center'}
              gap={'5px'}
              sx={{
                '& > .MuiTypography-root': {
                  fontSize: '10px',
                  color: '#a6a3a3',
                  wordBreak: 'break-all',
                  letterSpacing: '0.5px',
                },
                '& svg': {
                  width: '9px',
                  height: 'auto',
                  transition: 'transform .3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.2)',
                  },
                },
                overflow: 'hidden',
              }}
            >
              {ficheros.map((_file, index) => (
                <Typography key={_file.nombre_fichero}>
                  {_file.nombre_fichero}
                  <CancelOutlinedIcon
                    onClick={(e) => removeFileHandler(e, index)}
                    sx={{ color: 'red', width: '15px' }}
                  />
                </Typography>
              ))}
            </Stack>
          )}
        </Box>
      </Stack>
    </Stack>
  )
}

export default InvoiceDropZone
